export default {
  en: {
    errorsCount_one: 'error',
    errorsCount_other: 'errors',
    toPastWeeks_one: 'vs the past {{count}} week',
    toPastWeeks_other: 'vs the past {{count}} weeks',
    toPastMonths_one: 'vs the past {{count}} month',
    toPastMonths_other: 'vs the past {{count}} months',
  },
  ru: {
    errorsCount_one: 'ошибка',
    errorsCount_few: 'ошибки',
    errorsCount_many: 'ошибок',
    errorsCount_other: 'ошибок',
    toPastWeeks_one: 'к прошлым {{count}} неделе',
    toPastWeeks_few: 'к прошлым {{count}} неделям',
    toPastWeeks_many: 'к прошлым {{count}} неделям',
    toPastWeeks_other: 'к прошлым {{count}} неделям',
    toPastMonths_one: 'к прошлым {{count}} месяцу',
    toPastMonths_few: 'к прошлым {{count}} месяцам',
    toPastMonths_many: 'к прошлым {{count}} месяцам',
    toPastMonths_other: 'к прошлым {{count}} месяцам',
  },
  de: {
    errorsCount_one: 'Fehler',
    errorsCount_other: 'Fehler',
    toPastWeeks_one: 'vs. der letzten {{count}} Woche',
    toPastWeeks_other: 'vs. den letzten {{count}} Wochen',
    toPastMonths_one: 'vs. dem letzten {{count}} Monat',
    toPastMonths_other: 'vs. den letzten {{count}} Monaten',
  },
  pt: {
    errorsCount_one: 'erro',
    errorsCount_other: 'erros',
    toPastWeeks_one: 'vs. a {{count}} semana anterior',
    toPastWeeks_other: 'vs. as {{count}} semanas anteriores',
    toPastMonths_one: 'vs. o {{count}} mês anterior',
    toPastMonths_other: 'vs. os {{count}} meses anteriores',
  },
  fr: {
    errorsCount_one: 'erreur',
    errorsCount_other: 'erreurs',
    toPastWeeks_one: 'vs la {{count}} semaine précédente',
    toPastWeeks_other: 'vs les {{count}} semaines précédentes',
    toPastMonths_one: 'vs le {{count}} mois précédent',
    toPastMonths_other: 'vs les {{count}} mois précédents',
  },
  es: {
    errorsCount_one: 'error',
    errorsCount_other: 'errores',
    toPastWeeks_one: 'vs la {{count}} semana anterior',
    toPastWeeks_other: 'vs las {{count}} semanas anteriores',
    toPastMonths_one: 'vs el {{count}} mes anterior',
    toPastMonths_other: 'vs los {{count}} meses anteriores',
  },
};
